import { Nullable } from "../../types/common";
import { PDFEntitlementIcon } from "../../types/enums";
import React from "react";
import { VipIconSVG } from "../../assets/icons/VipIconSVG";
import { GoldIconSVG } from "../../assets/icons/GoldIconSVG";
import { SilverIconSVG } from "../../assets/icons/SilverIconSVG";
import { BronzeIconSVG } from "../../assets/icons/BronzeIconSVG";
import { CoffeeIconSVG } from "../../assets/icons/CoffeeIconSVG";
import { BuyerClubIconSVG } from "../../assets/icons/BuyerClubIconSVG";
import { ClosingDinnerIconSVG } from "../../assets/icons/ClosingDinnerIconSVG";
import { CocktailIconSVG } from "../../assets/icons/CocktailIconSVG";
import { EarlyAccessIconSVG } from "../../assets/icons/EarlyAccessIconSVG";
import { OnsiteAccessIconSVG } from "../../assets/icons/OnsiteAccessIconSVG";
import { OpeningDinnerIconSVG } from "../../assets/icons/OpeningDinnerIconSVG";
import { ConferenceIcon } from "../pdf/pdfDocument/icons/ConferenceIcon";

type PropsGetBadgeEntitlementIconByName = { iconName: Nullable<PDFEntitlementIcon>; isWithBorders?: boolean };

const getBadgeEntitlementIconByName = ({ iconName, isWithBorders }: PropsGetBadgeEntitlementIconByName) => {
  if (iconName === PDFEntitlementIcon.VIP) {
    return <VipIconSVG isWithBorder={isWithBorders} />;
  } else if (iconName === PDFEntitlementIcon.GOLD) {
    return <GoldIconSVG isWithBorder={isWithBorders} />;
  } else if (iconName === PDFEntitlementIcon.SILVER) {
    return <SilverIconSVG isWithBorder={isWithBorders} />;
  } else if (iconName === PDFEntitlementIcon.BRONZE) {
    return <BronzeIconSVG isWithBorder={isWithBorders} />;
  } else if (iconName === PDFEntitlementIcon.COFFEE) {
    return <CoffeeIconSVG isWithBorder={isWithBorders} />;
  } else if (iconName === PDFEntitlementIcon.BUYER_CLUB) {
    return <BuyerClubIconSVG isWithBorder={isWithBorders} />;
  } else if (iconName === PDFEntitlementIcon.CLOSING_DINNER) {
    return <ClosingDinnerIconSVG isWithBorder={isWithBorders} />;
  } else if (iconName === PDFEntitlementIcon.COCKTAIL) {
    return <CocktailIconSVG isWithBorder={isWithBorders} />;
  } else if (iconName === PDFEntitlementIcon.EARLY_ACCESS) {
    return <EarlyAccessIconSVG isWithBorder={isWithBorders} />;
  } else if (iconName === PDFEntitlementIcon.ONSITE_ACCESS) {
    return <OnsiteAccessIconSVG isWithBorder={isWithBorders} />;
  } else if (iconName === PDFEntitlementIcon.OPENING_DINNER) {
    return <OpeningDinnerIconSVG isWithBorder={isWithBorders} />;
  } else if (iconName === PDFEntitlementIcon.CONFERENCE) {
    return <ConferenceIcon />;
  }
  console.warn(`Invalid iconName property provided: ${iconName}`);
  return null;
};

const SVGUtils = {
  getBadgeEntitlementIconByName
};

export default SVGUtils;
